import { BrickWall, Hammer, Building2, Fence, Route, Paintbrush, Home, Briefcase, Landmark, Wrench } from "lucide-react";

export const ICONS = { BrickWall, Hammer, Building2, Fence, Route, Paintbrush, Home, Briefcase, Landmark, Wrench };

export function Icon({ name, ...props }) {
  const C = ICONS[name] || Wrench;
  return <C {...props} />;
}
